<template>
  <footer id="footer">
    <!-- 友情链接区域 -->
    <div class="head-container">
      <h3 class="title">伍號酒店欢迎您 開啟更多精彩</h3>
      <el-divider content-position="center">友 情 連 結</el-divider>

      <div class="connect-container">
        <div
          class="web-box"
          v-for="(item, index) in logoData"
          :key="index"
          @mouseenter="handleLogoHover(index, true)"
          @mouseleave="handleLogoHover(index, false)"
        >
          <a :href="item.webUrl" target="_blank" rel="noopener noreferrer">
            <img
              :src="item.url"
              :alt="`友情链接-${index + 1}`"
              :class="{ 'logo-hover': hoveredIndex === index }"
            />
          </a>
        </div>
      </div>
    </div>

    <!-- FOOTER CENTER -->
    <div class="footer_center">
      <div class="bg-line">
        <img
          src="../assets/images/bgline.png"
          alt="装饰线条"
          srcset=""
        />
      </div>

      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-5">
            <div class="widget widget_logo" >
              <div class="widget-logo" style="text-align: center;display: flex; align-items: center;">
                <div class="img">
                  <a href="/" aria-label="返回首页">
                    <img
                      src="../assets/images/hotel-logo01.png"
                      alt="伍號酒店logo"
                    />
                  </a>
                </div>
                <div class="text" >
                  <p>
                    <i class="lotus-icon-location"></i>
                    珠海市香洲区横琴粤澳深度合作区天羽道138号
                  </p>
                  <!-- <p>
                    <i class="lotus-icon-phone"></i>
                    <a href="tel:15488548898">1-548-854-8898</a>
                  </p> -->
                  <p>
                    <i class="fa fa-envelope-o"></i>
                    <a href="mailto:hq_hotel5@hqhotel5.com.cn"
                      >hq_hotel5@hqhotel5.com.cn</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-6 col-lg-3">
            <div class="widget">
              <h4 class="widget-title">网站页面</h4>
              <ul class="nav-list">
                <li><a href="/artspace" class="nav-link">艺术空间</a></li>
                <li><a href="/entertainment" class="nav-link">餐厅</a></li>
                <li><a href="/room" class="nav-link">酒店客房</a></li>
              </ul>
            </div>
          </div>

          <div class="col-xs-6 col-lg-4">
            <div class="widget">
              <h4 class="widget-title">关于我们</h4>
              <ul class="about-list">
                <li><a href="/about" class="nav-link">关于</a></li>
                <li><a href="/blog" class="nav-link">博客</a></li>
                <li><a href="/contact" class="nav-link">联系我们</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="footer_bottom">
        <div class="container">
          <p>Copyright © 2025 - 2100 HQ_Hotel5 Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footerCom",
  data() {
    return {
      drawerVisible: false, // 更语义化的命名
      hoveredIndex: -1, // 记录hover的logo索引
      logoData: [
        {
          url: require("@/assets/images/THX_web_logo.png"),
          webUrl: "http://www.starpeakstudios.com/",
        },
        {
          url: require("@/assets/images/ks_logo.png"),
          webUrl: "http://www.starpeakstudios.com/",
        },
        {
          url: require("@/assets/images/gx_real_logo.png"),
          webUrl: "http://www.starpeakstudios.com/",
        },
        {
          url: require("@/assets/images/ticket_logo.png"),
          webUrl: "https://www.macauticket.com/TicketWeb2023",
        },
        {
          url: require("@/assets/images/youxian_logo.png"),
          webUrl: "http://www.starpeakstudios.com/",
        },
      ],
      formData: {
        // 表单数据绑定
        nickname: "",
        phone: "",
        email: "",
      },
    };
  },
  methods: {
    // 打开抽屉
    openDrawer() {
      console.log(1);

      this.drawerVisible = true;
    },
    // 处理logo hover效果
    handleLogoHover(index, isHover) {
      this.hoveredIndex = isHover ? index : -1;
    },
    // 关闭抽屉前的确认
    handleDrawerClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
          // 关闭后重置表单
          this.formData = {
            nickname: "",
            phone: "",
            email: "",
          };
        })
        .catch(() => {
          // 取消关闭不做处理
        });
    },
    // 表单提交处理
    handleFormSubmit() {
      // 简单的表单验证
      if (!this.formData.nickname) {
        this.$message.error("请输入昵称");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.formData.phone)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
        this.$message.error("请输入正确的电子邮箱");
        return;
      }

      // 提交逻辑（示例）
      this.$message.success("提交成功！我们会尽快联系您");
      this.drawerVisible = false;
      // 重置表单
      this.formData = {
        nickname: "",
        phone: "",
        email: "",
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/style.css";

#footer {
  background-color: #acadb0;
  // background-image: url(../assets/images/hotelImg/footer1.jpg);
  // background-size: cover;
  // background-repeat: no-repeat;
  // background-position: center;
  width: 100% !important;
  // margin-top: 5vh;
} ///

.head-container {
  background-color: white;
  padding-bottom: 15px;
  padding-top: 50px;

  border-radius: 0 0 15px 15px;
  z-index: 1000;

  .connect-title {
    background-color: aqua;
    width: 80%;
    text-align: start;
    margin: auto;
  }

  .connect-container {
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;

    .web-box {
      width: 200px;
      margin: 10px 0;
      border-radius: 20px;
      overflow: hidden;
      cursor: pointer;
      box-shadow: 6px 4px 5px 0px rgba(128, 128, 128, 0.438);
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      img {
        width: 100%;
        display: block;
        transition: transform 0.2s linear;
      }

      .logo-hover {
        transform: scale(1.05);
      }
    }
  }
}

.footer_center {
  position: relative;
  overflow: hidden;

  .bg-line {
    height: 100%;
    position: absolute;
    bottom: 0;
    right: 0;

    img {
      height: 100%;
      transform: translate(40%, 0);
    }
  }
}

// 抽屉表单样式
::v-deep {
  .el-drawer__header {
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }

  .el-drawer__title {
    color: #333;
    font-size: 18px;
    font-weight: 600;
  }
}

.drawer-content {
  padding: 10px 0;

  .drawer-desc {
    color: #666;
    line-height: 1.6;
    margin-bottom: 20px;
  }

  .sub-container {
    width: 80%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 15px;

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 5px;

      label {
        color: #333;
        font-weight: 500;
        font-size: 14px;
      }

      input {
        display: block;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;

        &:focus {
          outline: none;
          border-color: orange;
          box-shadow: 0 0 0 2px rgba(255, 165, 0, 0.1);
        }
      }
    }

    .submit-btn {
      padding: 12px;
      background-color: orange;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #e67e22;
      }
    }
  }
}

@media (max-width: 768px) {
  .connect-container {
    width: 90%;
    margin: auto;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;

    .web-box {
      margin: 8px 0;
      border-radius: 20px;
      width: 120px !important;
      overflow: hidden;
      cursor: pointer;
      box-shadow: 6px 4px 5px 0px gray;

      &:hover {
        img {
          transform: scale(1.1);
          transition: 0.2s linear;
        }
      }
    }
  }
}

a {
  text-decoration: none !important;
  transition: all 0.3s ease;
}

.footer_bottom,
.footer_top {
  background-color: #acadb0 !important;
}

.widget {
  .widget-title {
    color: white !important;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid orange;
    display: inline-block;
  }

  .nav-list,
  .about-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .nav-link {
    color: white !important;
    transition: all 0.3s ease;

    &:hover {
      color: orange !important;
      padding-left: 5px;
    }
  }

  .contact-us-btn {
    transition: color 0.3s ease;

    &:hover {
      color: orange !important;
    }
  }
}

// 联系方式链接样式
.widget-logo .text p a {
  color: white;

  &:hover {
    color: orange;
    text-decoration: underline;
  }
}

.footer_bottom p {
  text-align: center;
  color: white;
  margin: 0;
  font-size: 14px;
}
</style>
